import { useEffect, useState } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import '@enterprise-ui/canvas-ui-css'
import { HelveticaForTarget } from '@enterprise-ui/component-font'
import { AuthProvider } from '@praxis/component-auth'
import { AnalyticsProvider } from '@praxis/component-analytics'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import './globalStyles/customStyles.scss'
import { Main } from './views/Main'
import { isExternalDomain } from './globalUtills/common'
import {
  setLocalStorage,
  getLocalStorage,
} from './globalUtills/browserStorageUtils'
import getAppConfig from './config/getAppConfig'
import { APP_CONSTANTS } from './globalConfig/appConstant'

const LOGIN_REDIRECT = window.location.origin

const App = () => {
  const [isConfigLoaded, setConfigLoaded] = useState(false)
  const [config, setConfig] = useState({
    apiKey: '',
    serviceName: 'itemhub',
  })
  const appConfig = getLocalStorage(APP_CONSTANTS.KEY_APP_CONFIG)

  useEffect(() => {
    getAppConfig().then((appConfig) => {
      setLocalStorage(APP_CONSTANTS.KEY_APP_CONFIG, appConfig)
      setConfig({
        apiKey: appConfig?.analytics?.apiKey || '',
        serviceName: 'itemhub',
      })
      setConfigLoaded(true)
    })
  }, [])

  OpenTelemetryManager.initialize(config)

  return isConfigLoaded ? (
    <>
      <HelveticaForTarget variants={['n4', 'n5', 'n7']} />
      <Router>
        <AuthProvider
          loginRedirect={LOGIN_REDIRECT}
          {...(isExternalDomain()
            ? appConfig.authExternal
            : appConfig.authInternal)}
        >
          <AnalyticsProvider
            eventManagerConfiguration={appConfig?.analytics}
            trackLocations
          >
            <Main />
          </AnalyticsProvider>
        </AuthProvider>
      </Router>
    </>
  ) : null
}

export default App
